import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import PhosphorIcon from '../PhosphorIcon';

import css from "./CTAButton.module.scss";

/* eslint-disable react/forbid-prop-types, react/jsx-props-no-spreading */

const CTAButton = ({
  children,
  href = "#",
  onClick = () => {},
  className = "",
  manualLink = false,
  style = {}
}) => {
  let Component = Link;
  const props = {};
  if (href === "#") {
    Component = "button";
    props.type = "button";
  } else if (manualLink || href.match(/^http(s)?:\/\//)) {
    Component = "a";
    props.href = href;
  } else {
    props.to = href;
  }
  if (typeof onClick === "function") {
    props.onClick = onClick;
  }
  return (
    <Component
      {...props}
      className={[css.ctaButton, className || ""].join(" ")}
      style={style}
    >
      <span className={css.contents}>{children}</span>

      <PhosphorIcon
      name="arrowRight"
      size="24"
      weight="bold"

    />
    </Component>
  );
};

CTAButton.propTypes = {
  children: PropTypes.any,
  href: PropTypes.string,
  onClick: PropTypes.func,
  manualLink: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.any
};

CTAButton.defaultProps = {
  children: [],
  href: "#",
  onClick: () => {},
  manualLink: false,
  className: "",
  style: {}
};

export default CTAButton;
